import NoSpecifications from "./no-specifications";
import NoResponses from "./no-responses";
import FilterEmpty from "./filter-empty";
import SearchEmpty from "./search-empty";

export default function EmptyState({
  variant,
  onCreateSpecificationWithAi,
  onImportSpecification,
  onCollectResponses,
  onClearFilters,
  searchTerm,
}: {
  variant: "noSpecifications" | "noResponses" | "filter" | "search";
  onCreateSpecificationWithAi: () => void;
  onImportSpecification: () => void;
  onCollectResponses: () => void;
  onClearFilters: () => void;
  searchTerm: string;
}) {
  return (
    <div className="flex flex-col items-center justify-center px-4 py-[80px] text-center w-full">
      {variant === "noSpecifications" && (
        <NoSpecifications
          onCreateSpecificationWithAi={onCreateSpecificationWithAi}
          onImportSpecification={onImportSpecification}
        />
      )}

      {variant === "noResponses" && (
        <NoResponses onCollectResponses={onCollectResponses} />
      )}

      {variant === "filter" && <FilterEmpty onClearFilters={onClearFilters} />}

      {variant === "search" && <SearchEmpty searchTerm={searchTerm} />}
    </div>
  );
}
